export default {
  identity: {
    information: [
      { name: 'Legal Name', value: 'legal_name' },
      { name: 'Identifiers', mc_value: 'mc_docket', dot_value: 'dot' },
      { name: 'Authority', value: 'authority' },
    ],
    physicalAddress: [
      { name: 'Address Line 1', value: 'street1' },
      { name: 'Address Line 2', value: 'street2' },
      { name: 'City', value: 'city' },
      { name: 'State', value: 'state' },
      { name: 'Zip', value: 'postal_code' },
      { name: 'Country', value: 'nationality' },
    ],
    mailingAddress: [
      { name: 'Address Line 1', value: 'street1' },
      { name: 'Address Line 2', value: 'street2' },
      { name: 'City', value: 'city' },
      { name: 'State', value: 'state' },
      { name: 'Zip', value: 'postal_code' },
      { name: 'Country', value: 'nationality' },
    ],
    contactInformation: [
      { name: 'Phone(s)', value: 'phone_number' },
      { name: 'Email(s)', value: 'email' },
    ],
    identification: [
      {
        name: 'Ein or Ssn (Required)',
        value: 'ssn',
        placeholder: 'Enter EIN or SSN',
        pattern: 'number',
      },
      {
        name: 'Dispatcher Phone # (Required)',
        value: 'dispatcher_phone_number',
        placeholder: 'Enter dispatcher phone #',
        pattern: 'number',
      },
      {
        name: 'Dispatcher Email (Required)',
        value: 'dispatcher_email',
        placeholder: 'Enter dispatcher email',
      },
    ],
  },
  operations: {
    modes: [
      { name: 'Air', value: 'air' },
      { name: 'Drayage', value: 'drayage' },
      { name: 'LTL', value: 'ltl' },
      { name: 'Inland Coastal', value: 'inland_coastal' },
      { name: 'Ocean', value: 'ocean' },
      { name: 'Parcel', value: 'parcel' },
      { name: 'Rail', value: 'rail' },
      { name: 'Truckload', value: 'truckload' },
    ],
    truck_information: [
      {
        name: 'Total Power Units',
        value: 'total_power_units',
        placeholder: '10',
      },
      { name: 'Total Drivers', value: 'total_drivers', placeholder: '10' },
    ],
    popular_trailer_types: [
      { name: 'Van', value: 'van' },
      { name: 'Reefer', value: 'reefer' },
      { name: 'Flatbed', value: 'flatbed' },
      // { name: "Truck Tractor", value: "truck_tractor"},
      {
        name: "I don't use any of the above trailers",
        value: "I don't use any of the above trailers",
      },
    ],
    // other_trailer_types: ["Belts", "Bulk", "Cargo Van", "Curtain", "Dumps", "Double Drop", "Gooseneck", "Haz", "Heavy", "Hoppers", "Inter", "Live Bottom", "LTL", "Pneum", "Sprinter Vans", "Step", "Straight/Box Trucks", "Teams", "Tank", "Tank Endorsement", "WH", "Walking Floors"],
    other_trailer_types: [
      { name: 'Inter', value: 'intermodal' },
      { name: 'Tanker', value: 'tanker' },
      { name: 'Heavy Haul', value: 'heavy_haul' },
      { name: 'Dumps', value: 'dumps' },
      { name: 'Grain', value: 'grain' },
      { name: 'Car Hauler', value: 'car_hauler' },
      { name: 'Pneum', value: 'pneumatic' },
      { name: 'Forestry', value: 'forestry' },
      { name: 'Refuse Transfer', value: 'refuse_transfer' },
      { name: 'Livestock', value: 'livestock' },
      { name: 'Lowboy', value: 'lowboy' },
      { name: 'Drop Deck', value: 'drop_deck' },
      { name: 'Double Drop', value: 'double_drop' },
      // { name: "Cargo Vans", value: "cargo_vans" },
      // { name: "Straight/Box Trucks", value: "straight_box_trucks" },
    ],
    // specializations: ["Alaska", "C-TPAT", "DOD", "Hot Shot", "In Bond", "Interstate", "Intrastate", "Liquor", "Mexico Thru Trailer", "Power Only", "Regional"],
    specializations: [
      { name: 'Alaska', value: 'alaska' },
      // { name: "C-TPAT", value: "ctpat" },
      { name: 'DOD', value: 'dod' },
      { name: 'Heavy', value: 'heavy' },
      { name: 'Hot Shot', value: 'hot_shot' },
      { name: 'In Bond', value: 'in_bond' },
      // { name: "Interstate", value: "interstate" },
      // { name: "Intrastate", value: "intrastate" },
      { name: 'Liquor', value: 'liquor' },
      { name: 'Local', value: 'local' },
      { name: 'Mexico Thru Trailer', value: 'mex_thru_trailer' },
      { name: 'Power Only', value: 'power_only' },
      { name: 'Regional', value: 'regional' },
      { name: 'Warehouse', value: 'warehouse' },
      { name: 'Tank Endorsement', value: 'tank_endorse' },
      { name: 'Team Driving', value: 'team_drivers' },
      // { name: "Warehouse", value: "warehouse" }, ltl
      // { name: "Warehouse", value: "warehouse" }, team drivers
    ],
  },
  lanes: {
    statesByRegion: {
      Midwest: [
        'WI',
        'SD',
        'OH',
        'ND',
        'NE',
        'MO',
        'MN',
        'MI',
        'KS',
        'IA',
        'IN',
        'IL',
      ],
      Southwest: ['TX', 'OK', 'NM', 'AZ'],
      Southeast: [
        'WV',
        'DC',
        'VA',
        'TN',
        'SC',
        'NC',
        'MS',
        'MD',
        'LA',
        'KY',
        'GA',
        'FL',
        'DE',
        'AR',
        'AL',
      ],
      'Rocky Mountain': ['WY', 'UT', 'NV', 'MT', 'ID', 'CO'],
      Pacific: ['WA', 'OR', 'CA'],
      Northeast: ['VT', 'RI', 'PA', 'NY', 'NJ', 'NH', 'MA', 'ME', 'CT'],
    },
  },
  certifications: {
    fmsca_certifications: [
      { is_type: 'CarbTru' },
      { is_type: 'PHMSA' },
      { is_type: 'SmartWay' },
      { is_type: 'CARB Truck and Bus' },
      { is_type: 'CTPAT' },
      { is_type: 'Tank Endorsed Drivers' },
      { is_type: 'TSA' },
      { is_type: 'TWIC' },
      { is_type: 'Women-Owned Business' },
      { is_type: 'Minority-Owned Business' },
      { is_type: 'Veteran-Owned Business' },
      { is_type: 'Disability-Owned Business' },
    ],
    fmsca_certifications_str: [
      'CarbTru',
      'PHMSA',
      'SmartWay',
      'CTPAT',
      'TWIC',
      'Tank Endorsed Drivers',
      'CARB Truck and Bus',
      'TSA',
      'Women-Owned Business',
      'Minority-Owned Business',
      'Veteran-Owned Business',
      'Disability-Owned Business',
    ],
    untracked_certifications: [
      'CARB Truck and Bus',
      'CTPAT',
      'Tank Endorsed Drivers',
      'TSA',
      'TWIC',
      'Women-Owned Business',
      'Minority-Owned Business',
      'Veteran-Owned Business',
      'Disability-Owned Business',
    ],
  },
  insurance: {
    auto_liability: {
      insurer_details: [
        { name: 'Insurer', value: 'insurer_name' },
        { name: 'Address Line 1', value: 'address_1' },
        { name: 'Address Line 2', value: 'address_2' },
        { name: 'City', value: 'city' },
        { name: 'State', value: 'state' },
        { name: 'Zip', value: 'zip' },
        { name: 'Country', value: 'country' },
      ],
      policy_details: [
        { name: 'Policy #', value: 'policy_number' },
        { name: 'Effective Date', value: 'effective_date' },
        { name: 'Limit', value: 'policy_limit' },
      ],
    },
    policy_exclusions: [
      { name: 'Alcohol', value: 'alcohol' },
      { name: 'Electronics', value: 'electronics' },
      { name: 'Employee Theft/Fraud', value: 'employee_theft_or_fraud' },
      { name: 'Garments', value: 'garments' },
      { name: 'Precious Metals', value: 'precious_metals' },
      // { name: 'Reefer/ Mech. Breakdown', value: "reefer_or_mechanical_breakdown" },
      { name: 'Seafood', value: 'seafood' },
      { name: 'Spoilage', value: 'spoilage' },
      { name: 'Unattended Vehicle', value: 'unattended_vehicle' },
    ],
  },
  contract: {
    information: [
      {
        name: 'Ein or Ssn (Required)',
        value: 'ein',
        placeholder: 'Enter EIN or SSN',
        pattern: 'number',
      },
    ],
    physicalAddress: [
      { name: 'Address 1', value: 'address_1' },
      { name: 'Address 2', value: 'address_2' },
      { name: 'City', value: 'city' },
      { name: 'State', value: 'state' },
      { name: 'Zip', value: 'zip', pattern: 'number' },
      { name: 'Country', value: 'country' },
    ],
    taxpayerIdNumber: [{ name: 'TIN', value: 'tax_payer_id' }],
    tax_classification: [
      {
        name: 'Tax Classification',
        value: 'tax_classification',
        placeholder: 'Enter C, S, or P',
      },
    ],
    federal_tax_class: [
      {
        name: 'Individual/Sole proprietor',
        value: 'individual',
      },
      { name: 'C Corporation', value: 'c_corporation' },
      { name: 'S Corporation', value: 's_corporation' },
      { name: 'Partnership', value: 'partnership' },
      { name: 'Trust/Estate', value: 'trust_or_estate' },
      { name: 'Limited Liability Company', value: 'limited_liability_company' },
      { name: 'Other', value: 'other' },
    ],
    authorize_name: [
      {
        name: 'Enter Full Name',
        value: 'authorize_name',
        placeholder: 'Enter first and last name',
      },
    ],
    authorize_signature: [
      {
        name: 'I acknowledge this electronic signature holds the same authority as a traditional signature.',
        value: 'authorize_signature',
      },
    ],
    tax_form_selection_tooltip:
      '<div> <div class="sm:flex sm:items-center"> <div class="sm:flex-auto"> <h1 class="text-xl font-semibold text-gray-900">Which Tax Form Should I Complete?</h1> <p class="text-sm text-gray-700">Provided for illustrative purposes only. Please consult with a tax professional regarding proper form selection and accuracy.</p> </div> </div> <div class="flex flex-col"> <div> <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8"> <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"> <table class="min-w-full divide-y divide-gray-300"> <thead class="bg-gray-50"> <tr> <th scope="col" class="py-2 pl-3 pr-2 text-left text-sm font-semibold text-gray-900">Tax Form</th> <th scope="col" class="relative py-2 pl-2 pr-3 text-left text-sm font-semibold text-gray-900">When Form May Apply</th> </tr> </thead> <tbody class="divide-y divide-gray-200 bg-white"> <tr> <td class="align-top py-2 pl-3 pr-2 text-sm font-medium text-gray-900 whitespace-nowrap">W-9</td> <td class="align-top relative py-2 pl-2 pr-3 text-left text-sm font-medium"><div class="w-56">You are a U.S. citizen or other U.S. person, including a resident alien individual</div></td> </tr> <tr> <td class="align-top py-2 pl-3 pr-2 text-sm font-medium text-gray-900 whitespace-nowrap">W-8BEN</td> <td class="align-top relative py-2 pl-2 pr-3 text-left text-sm font-medium"><div class="w-56">You are a foreign individual, and neither W-8ECI nor Form 8233 apply</div></td> </tr> <tr> <td class="align-top py-2 pl-3 pr-2 text-sm font-medium text-gray-900 whitespace-nowrap">W-8BEN-E</td> <td class="align-top relative py-2 pl-2 pr-3 text-left text-sm font-medium"><div class="w-56">You are a foreign entity, and W-8ECI does not apply</div></td> </tr> <tr> <td class="align-top py-2 pl-3 pr-2 text-sm font-medium text-gray-900 whitespace-nowrap">W-8ECI</td> <td class="align-top relative py-2 pl-2 pr-3 text-left text-sm font-medium"><div class="w-56">A foreign individual or entity claiming that income is effectively connected with the conduct of trade or business within the United States (unless claiming treaty benefits)</div></td> </tr> <tr> <td class="align-top py-2 pl-3 pr-2 text-sm font-medium text-gray-900 whitespace-nowrap">Form 8233</td> <td class="align-top relative py-2 pl-2 pr-3 text-left text-sm font-medium"><div class="w-56">You are a foreign individual and beneficial owner who is receiving compensation for personal services performed in the United States</div></td> </tr> </tbody> </table> </div> </div> </div> </div> </div>',
  },
  integrations: {
    systems: [
      { name: 'AscendTMS', svg: 'ascend.svg' },
      { name: 'McLeod', svg: 'McLeod.png' },
      { name: 'Smarthop', svg: 'smarthop.svg' },
      { name: 'Macropoint', svg: 'macropoint.svg' },
      { name: 'Fourkites', svg: 'fourkites.svg' },
      { name: 'Keeptruckin', svg: 'keeptruckin.svg' },
    ],
    shared_data: [
      { type: 'Capacity', integration: 'Keeptruckin' },
      { type: 'Tendering', integration: 'Keeptruckin' },
      { type: 'Track and Trace', integration: 'Keeptruckin' },
      { type: 'Invoicing', integration: 'Keeptruckin' },
    ],
  },
  payment: {
    sample_addresses: [
      {
        address_1: '1234 Easy St',
        city: 'Dallas',
        state: 'TX',
        zip: '75001',
        country: 'USA',
      },
      {
        address_1: '1235 Easy St',
        city: 'Dallas',
        state: 'TX',
        zip: '75001',
        country: 'USA',
      },
      {
        address_1: '1236 Easy St',
        city: 'Dallas',
        state: 'TX',
        zip: '75001',
        country: 'USA',
      },
      {
        address_1: '1237 Easy St',
        city: 'Dallas',
        state: 'TX',
        zip: '75001',
        country: 'USA',
      },
    ],
    sample_factoring_companies: [
      {
        name: 'Factoring Comp',
        location: 'St.Louis, MO',
        email: 'factoring1@gmail.com',
        phone_number: '123-456-7859',
      },
      {
        name: 'Factoring Company',
        location: 'Dallas, TX',
        email: 'factoring2@gmail.com',
        phone_number: '123-612-5123',
      },
      {
        name: 'Factoring Companies',
        location: 'Anchorage, AK',
        email: 'factoring3@gmail.com',
        phone_number: '123-434-5592',
      },
    ],
    sample_banks: {
      123456789: 'Bank of America',
      111111111: 'Bank of America',
      222222222: 'Chase',
      333333333: 'Citi',
    },
  },
  verify_physical_assets: {
    verification_options: [
      {
        name: 'Instantly',
        subtext: 'Authenticate through a provider',
        value: 'instant',
      },
      {
        name: 'Manually',
        subtext: 'Email Highway compliance',
        value: 'manual',
      },
    ],
    integration_options: [
      {
        name: 'Motive',
        value: 'motive',
        bg_brand_color_class: 'brand-motive',
      },
      {
        name: 'Samsara',
        value: 'samsara',
        bg_brand_color_class: 'brand-samsara',
      },
    ],
  },
};
